import { render, staticRenderFns } from "./PublicLinkItem.vue?vue&type=template&id=e0fc8b60&scoped=true"
import script from "./PublicLinkItem.vue?vue&type=script&lang=js"
export * from "./PublicLinkItem.vue?vue&type=script&lang=js"
import style0 from "./PublicLinkItem.vue?vue&type=style&index=0&id=e0fc8b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fc8b60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VChip,VIcon,VSheet})
